/**
 * Created by Carsten Bühler
 * User: c.buehler on 26.09.2016
 * Copyright: xdot GmbH 2015
 */

import React from 'external/react';
import PropTypes from 'external/prop-types';
import { Form } from 'external/react-bootstrap';

export default function ValidationMessage(props) {

    const { formValidation, propName } = props;

    if (formValidation && formValidation[propName]) {
        return (
            <Form.Text>{formValidation[propName]}</Form.Text>
        );
    } else {
        return null;
    }
}

ValidationMessage.propTypes = {
    formValidation: PropTypes.object,
    propName: PropTypes.string
};



// WEBPACK FOOTER //
// ./js/components/ValidationMessage.jsx